import { render, staticRenderFns } from "./IconStripe.vue?vue&type=template&id=15f8b6da&"
import script from "./IconStripe.vue?vue&type=script&lang=js&"
export * from "./IconStripe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f8b6da')) {
      api.createRecord('15f8b6da', component.options)
    } else {
      api.reload('15f8b6da', component.options)
    }
    module.hot.accept("./IconStripe.vue?vue&type=template&id=15f8b6da&", function () {
      api.rerender('15f8b6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconStripe.vue"
export default component.exports